module.exports = __webpack_public_path__ + "prod/1.42.2/img/customer-15.a751fa05.jpg";